import { useContext, useEffect, useReducer, useRef, useState } from "react"
import { Contexto } from "../Context/Contexto"
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion"
import { tokens } from "../Context/Tokens"
import { AmigoReferido, EnvioCorreos } from "../Model/AmigoReferido"
import { Get, Post2 } from "../Rutas/ApiRest"
import { AmigoReferid, Redireccion} from "../Rutas/Servicios"
import { MensajeCont } from "../Context/MensajeContext"

function AmigoReferidos()
{
    const [mensaje,SetMensaje]=useState<{mensaje:string,respuesta:boolean,nombre:string}>({
        mensaje:"",respuesta:false,nombre:""
      })
      const [state,dispatch]=useReducer(reducer,{email:"",nombre:""})
      const [amigo,SetAmigo]=useState<AmigoReferido[]>()
      const [Empresa,SetEmpresa]=useState<boolean>(false)
      const {SetMensajeEmergente,SetLoading}=useContext(MensajeContActualizacion)
      const {Cli}=useContext(Contexto)
      const {tok}=useContext(tokens)
      const [activado,SetActivado]=useState<number>(1)
      const [respuesta,SetRespuesta]=useState<string>("")
      const {Redireccionamiento,SetRedireccionamiento}=useContext(MensajeCont)
      function cambio(event:any)
    {
      dispatch({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
      
    }
    
    
    const ConfirmacionAMigoReferido=()=>{
        const datos=Get(AmigoReferid.ValidacionEmpresa.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode) ,"application/json",tok)
        datos?.then(resultado=>{SetEmpresa(resultado)})
      }
   function reducer(state:any,action:any)
  {
    switch(action.type)
    {
      case "cambio":return {
        ...state,[action.input.name]:action.input.value
      }
      case "Reinicio":return{email:"",nombre:""}
    }
   
    return state;
  }

  useEffect(()=>
  {
    if(Empresa)
    {
      if(Redireccion!=undefined)
      {
        if(Redireccionamiento!="")
        {
          window.location.hash=Redireccionamiento
          SetRedireccionamiento("")
        }
      }
    }
    
    
  },[Empresa])

  useEffect(()=>{
    if(Cli.lCasilla[Cli.Eleccion].ecode!="")
    {
      ConfirmacionAMigoReferido();
    }
    
  },[Cli.lCasilla])
  const AmigosRefe=()=>{

    if(VerificarCorreo(state.email))
    {
      var raw={"ecode":Cli.lCasilla[Cli.Eleccion].ecode,"email":state.email};
      const datos=Post2(AmigoReferid.ValidacionCorreo,JSON.stringify(raw),"application/json",tok)
      datos.then(resultado=>SetMensaje(resultado))
    }else
    {
      SetMensaje({mensaje:"Ya ingreso este correo",respuesta:false,nombre:""})
      SetMensajeEmergente("Ya ingreso este correo")
    }

    
  }

  useEffect(()=>{
    if(mensaje.respuesta)
    {
      if(amigo===undefined)
      {
        SetAmigo([{email:state.email,nombre:state.nombre}])
      }else{
        SetAmigo((e:any)=>[...e,{email:state.email,nombre:state.nombre}])
      } 
      dispatch({type:"Reinicio"})
    }
  },[mensaje])
  
  const EnvioAmigo=()=>{
    dispatch({type:"Reinicio"})
    if(amigo!=undefined)
    {
      const dat=amigo.map((e)=>{return {"email": e.email,"nombre":e.nombre}})
      const contenido:EnvioCorreos={ecode:Cli.lCasilla[Cli.Eleccion].ecode,correo:dat}
      const datos=Post2(AmigoReferid.EnviarNotificaciones,JSON.stringify(contenido) ,"application/json",tok)
      datos.then(resultado=>{SetRespuesta(resultado);SetActivado(1);SetLoading(false);SetMensajeEmergente(resultado)})

      SetAmigo(undefined)
    }  
  }

  const VerificarCorreo=(email:string)=>
  {
    if(amigo!=undefined)
    {
      const resultado=amigo.filter((e:AmigoReferido)=>e.email.toUpperCase()==email.toUpperCase());
      if(resultado.length>0)
      {
        return(false)
      }else
      {
        return(true)
      }
    }else
    {
      return(true)
    }
    
    
  }

    return (
        <>
            {Empresa?
            <>
            <div className="row" >
                    <div className="col-12 col-md-12" >
        <div className="fondo-blanco h-100">
          <div className="card">
            
            <div className="card-body">
              
            <div className="card-body text-secondary px-sm-4" id="Amigo">
            <p className="subtitulo">Refiere un amigo y gana</p>
                      <div className="row">
                        <div className="col-12 col-sm-4 px-sm-4 py-2 py-sm-0"><i className="bi bi-person-plus-fill"></i>
                          <p><strong>Invita a tus amigos</strong></p>
                          <p>Ingresa los correos de tus amigos y envíales un invitación o comparte por redes sociales</p>
                        </div>
                        <div className="col-12 col-sm-4 px-sm-4 py-2 py-sm-0"><i className="bi bi-currency-dollar"></i>
                          <p><strong>Gana Dinero</strong></p>
                          <p>Tu amigo gana US $10* al registrarse en su primera orden y ¡Tú recibes US $10*!</p>
                        </div>
                        <div className="col-12 col-sm-4 px-sm-4 py-2 py-sm-0"><i className="bi bi-cart-fill"></i>
                          <p><strong>Sigue Comprando</strong></p>
                          <p>Multiplica eso por todos tus amigos a los que les gusta comprar en USA y tendrás MUCHO dinero.</p>
                        </div>
                      </div>
                      </div>
                      
              <div className="accordion" id="accordionAmigoRef">
                <div className="accordion-item" >
                  <h2 className="accordion-header" id="flush-AmigoOne">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseAmigoOne" aria-expanded="false" aria-controls="flush-CollapseAmigoOne"> Refiere a tus amigos por Redes Sociales</button>
                  </h2>
                  <div id="flush-collapseAmigoOne" className="accordion-collapse collapse" aria-labelledby="flush-AmigoOne" data-bs-parent="#accordionAmigoRef">
                    <div className="accordion-body">
                    <div >
                    <p className="subtitulo">Refiere a tus amigos por redes sociales</p>
                    <div className="col-12">
        <div className="row">
            <div className="col-sm-4 my-1 px-sm-2">
            <a href={"https://api.whatsapp.com/send/?text=Registrate en Eshopex y obten US$10 para usar al momento del pago "+Redireccion.UrlAmigoReferido+Cli.lCasilla[Cli.Eleccion].ecode} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}> <button className="btn btn-success" style={{background:"#128c7e",borderColor:"#128c7e"}} >
                Compartir por Whatsapp
            </button></a>
            </div>
            <div className="col-sm-4 my-1 px-sm-2">
                <a  href={"https://www.facebook.com/share_channel/?link="+Redireccion.UrlAmigoReferido+Cli.lCasilla[Cli.Eleccion].ecode+"&source_surface=external_reshare&display=popup"} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}>  <button className="btn btn-success" style={{background:"#1877f2",borderColor:"#1877f2"}} >
                Compartir por Facebook
        </button></a> 
            </div>
            <div className="col-sm-4 my-1 px-sm-2">
                <a href={"https://www.reddit.com/submit?url="+Redireccion.UrlAmigoReferido+Cli.lCasilla[Cli.Eleccion].ecode+"&title=Registrate en Eshopex y obten US$10 para usar al momento del pago "} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}>   <button className="btn btn-success" style={{background:"#ff4500",borderColor:"#ff4500"}}>
                Compartir por Reddit
        </button></a>
            </div>
            <div className="col-sm-4 my-1 px-sm-2">
                <a href={"https://twitter.com/intent/post?url=Registrate en Eshopex y obten US$10 para usar al momento del pago "+Redireccion.UrlAmigoReferido+Cli.lCasilla[Cli.Eleccion].ecode} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}>   <button className="btn btn-success" style={{background:"#212529",borderColor:"#212529"}}>
                Compartir por X
        </button></a>
            </div>
            <div className="col-sm-4 my-1 px-sm-2" >
            
            <input  type="submit" name="ctl00$ContentPlaceHolder_body$Agregar_btn" value="Copiar Vínculo" id="ContentPlaceHolder_body_Agregar_btn" className="btn btn-primary" style={{backgroundColor:"#f98824",borderColor:"#f98824"}} onClick={() => {navigator.clipboard.writeText(Redireccion.UrlAmigoReferido+Cli.lCasilla[Cli.Eleccion].ecode);SetMensajeEmergente("Vínculo copiado")}}/>
            </div>
        </div> 

    </div>         
        
                          </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-AmigoTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseAmigoTwo" aria-expanded="false" aria-controls="flush-CollapseAmigoTwo"> Refiere a tus amigos por Email </button>
                  </h2>
                  <div id="flush-collapseAmigoTwo" className="accordion-collapse collapse" aria-labelledby="flush-AmigoTwo" data-bs-parent="#accordionAmigoRef">
                  <div className="accordion-body">
                  <div className="row">
                        <div className="col-sm-12" >
                          <p className="subtitulo">Refiere amigos aquí</p><br/>
                          {mensaje.respuesta===false?<div className="texto"><p className="subtitulo">{mensaje.mensaje}</p></div>:null} 
                          {/* <!-- form--> */}
                          <div id="ContentPlaceHolder_body_pnlClientDiscount">
                            <div className="row align-items-center">
                              <div className="col-sm-4 my-1 px-sm-2"> <span id="ContentPlaceHolder_body_Nombre_lbl" className="sr-only">Nombre</span>
                                <input name="nombre" type="text" value={state.nombre} onChange={cambio} className="form-control" placeholder="Nombre"/>
                              </div>
                              <div className="col-sm-4 my-1 px-sm-2"> <span id="ContentPlaceHolder_body_Email_lbl" className="sr-only">Email</span>
                                <div className="input-group" >
                                  <input name="email" type="text" value={state.email} onChange={cambio} className="form-control" placeholder="Email"/>
                                </div>
                              </div>
                              <div className="col-auto my-1" >
                                <input type="submit"  name="ctl00$ContentPlaceHolder_body$Agregar_btn" value="AGREGAR" id="ContentPlaceHolder_body_Agregar_btn" style={{backgroundColor:"#f98824",borderColor:"#f98824"}} className="btn btn-primary" onClick={()=>AmigosRefe()}/>
                              </div>
                            </div>
                            <div className="row align-items-center" >
                              
                            {amigo?.map((e)=><><div className="row">  <div className="col-sm-4 my-1 px-sm-2"> <span id="ContentPlaceHolder_body_Nombre_lbl" className="sr-only"></span>
                              <h5>{e.nombre}</h5>
                              </div>
                            <div className="col-sm-4 my-1 px-sm-2"> <span id="ContentPlaceHolder_body_Nombre_lbl" className="sr-only"></span>
                            <h5>{e.email}</h5>
                            </div></div> <br/></>)}
                              {amigo!==undefined?amigo.length>0?<div >
                              <input  type="submit" name="ctl00$ContentPlaceHolder_body$Agregar_btn" value="Enviar invitación" id="ContentPlaceHolder_body_Agregar_btn" className="btn btn-primary" style={{backgroundColor:"#f98824",borderColor:"#f98824"}} onClick={()=>{SetLoading(true);EnvioAmigo()}}/>
                            </div>:null:null}   
                            </div>

                           
                          </div>
                          {/* <!-- /form-->  */}
                        </div>
                        <div className="col-sm-4">
                          <br/>
                          
                          </div>
                      </div>
                    </div>
                  </div>
                </div>          
              </div>
            </div>
          </div>
        </div>
                </div>
                </div>
            </>
              :null}
        </>
    )
}

export default AmigoReferidos